import { formatMoney} from "//wellboxes.co.uk/cdn/shop/t/44/assets/theme.js?v=45972817138175999841765220852";
var VolumePricing = class extends HTMLElement {
    constructor() {
        super();      
    }

    connectedCallback() {
        this.current_price = this.querySelector('#volume-price');
        this.original_price = this.querySelector('#original-price');
        this.unit_price = this.querySelector('#unit-price');
        window.addEventListener('volume:pricing:total', this.selectCurrentVolume.bind(this));
    }

    selectCurrentVolume(event){
       var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
       var unit_cost = Math.round(event.setTotal.price);
       var unit_volume = event.setTotal.qty;
       var unit_discount = event.setTotal.percentage;
       var suffix = this.current_price.dataset.priceSuffix+" <span class='free-delivery-reference text-sm'>Including Free UK Delivery</span>";
       this.setUnitCost(unit_cost);

  
       var subtotal_amount =  this.original_price.dataset.originalPrice * unit_volume;
       var discounted_amount = subtotal_amount * unit_discount; 
       var discounted_total = subtotal_amount - discounted_amount;
       if(unit_discount > 0){
        this.current_price.innerHTML = formatMoney(discounted_total, currencyFormat) + suffix; 
       } else {
        this.current_price.innerHTML = formatMoney(unit_cost * unit_volume , currencyFormat) + suffix;
       }
       

       if(unit_cost != this.original_price.dataset.originalPrice ){
        //this.original_price.style.display = 'block';
        var orignal_cost = this.original_price.dataset.originalPrice
        
        this.original_price.innerHTML = formatMoney(subtotal_amount, currencyFormat);
       } else {
        //this.original_price.style.display = 'none';
       }
    }

    setUnitCost(unit_cost){
      var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
      this.unit_price.innerHTML = formatMoney(unit_cost, currencyFormat) + " per unit";
    
    }

  };
  if (!window.customElements.get("volume-pricing")) {
    window.customElements.define("volume-pricing", VolumePricing);
  }
  

